import { Injectable } from '@angular/core';
import { FAN_MANAGEMENT_KEY_LABEL, INSIGHT_TAB, USER_ACTIONS } from '@modules/insights/components/constant';

@Injectable({ providedIn: 'root' })
export class InsightsStateService {
  tabType = INSIGHT_TAB.EARNING;
  frmTabType = INSIGHT_TAB.FAN_MANAGEMENT;
  fanTabKey = INSIGHT_TAB.ALL;
  fanManagementDateRange: Date[] | null = null;
  fanDetailsTabKey = FAN_MANAGEMENT_KEY_LABEL.purchase;
  selectedFanFilter: string | null = USER_ACTIONS.ALL;
}
